import { createContext as o } from "react";

const e = o({
    close: () => {},
    softClose: () => {},
    idPrefix: ""
});

export { e as default };
//# sourceMappingURL=index.js.map
